import {Typography} from 'components/Typography';
import {useAppDispatch} from 'core/redux/hooks/useAppDispatch';
import {MODALS} from 'modules/modals/constants';
import {showModal} from 'modules/modals/thunks';
import {FC, useContext} from 'react';
import style from './style.module.scss';
import classNames from 'classnames';
import {EventsListContext} from 'modules/events/context';

export const BannerYouRules: FC = () => {
    const dispatch = useAppDispatch();

    const {isLoading} = useContext(EventsListContext);

    const onClick = () => {
        dispatch(showModal(MODALS.INDIVIDUAL_TASTING.name));
    };

    return (
        <div className={classNames(style.main, {[style.isLoading]: isLoading})} data-skeleton-item={true}>
            <Typography variant={'ch-title-32-reg'}>Мероприятие с дегустацией на компанию по вашим правилам</Typography>
            <Typography variant={'body-16-r'}>Организуем под ваш запрос винный вечер с закусками</Typography>
            <button className={style.button} onClick={onClick} type={'button'}>
                <Typography variant={'label-14-r-fluid'}>Запросить</Typography>
            </button>
        </div>
    );
};
